enum TextEnum {
    Menu,
    PersonalDataName,
    PersonalDataBirthDate,
    PersonalDataEmail,
    CurriculumAboutMe,
    CurriculumGoals,
    CurriculumEducation,
    CurriculumWorkExperience,
    CurriculumFreelances,
    CurriculumSkils,
    CurriculumExtracurricularActivities
}

export default TextEnum;
